import React from 'react'
import Header from '../../../../Components/Header'
import Footer from '../../../../Components/Footer'
import Lpntable from './Components/Lpn-table'
import { Helmet } from 'react-helmet'

const Salesordermanual = () => {
  return (
        <div className='d-flex flex-column' style={{minHeight:'99.7vh'}}>
        <Helmet>
				  <title>Sales Order List</title>
			  </Helmet>
        <Header />
        <Lpntable />
        {/* <Footer /> */}
    </div>
  )
}

export default Salesordermanual